import { gql } from "@apollo/client";

export const manageComplaintsState = {
  complaintID: "",
  customerName: "",
  soNumber: "",
  product: "",
  productPurchaseDate: "",
  complaintDate: "",
  complaintDescription: "",
  attachment: "",
  severityLevel: "",
};

export const manageComplaintsStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "complaintID": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          complaintID: value,
          complaintIDStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          complaintID: "",
          complaintIDStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          complaintID: value,
          complaintIDStatus: "error",
        };
      }
    }
    case "customerName": {
      if (value) {
        return {
          ...state,
          customerName: value,
          customerNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customerName: "",
          customerNameStatus: "unchecked",
        };
      }
    }
    case "soNumber": {
      if (value) {
        return {
          ...state,
          soNumber: value,
          soNumberStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          soNumber: "",
          soNumberStatus: "unchecked",
        };
      }
    }
    case "product": {
      if (value) {
        return {
          ...state,
          product: value,
          productStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          product: "",
          productStatus: "unchecked",
        };
      }
    }
    case "productPurchaseDate": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productPurchaseDate: value,
          productPurchaseDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productPurchaseDate: "",
          productPurchaseDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productPurchaseDate: value,
          productPurchaseDateStatus: "error",
        };
      }
    }
    case "complaintDate": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          complaintDate: value,
          complaintDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          complaintDate: "",
          complaintDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          complaintDate: value,
          complaintDateStatus: "error",
        };
      }
    }
    case "complaintDescription": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          complaintDescription: value,
          complaintDescriptionStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          complaintDescription: "",
          complaintDescriptionStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          complaintDescription: value,
          complaintDescriptionStatus: "error",
        };
      }
    }
    case "attachment": {
      if (value) {
        return {
          ...state,
          attachment: value,
          attachmentStatus: true,
        };
      } else if (!value) {
        return {
          ...state,
          attachment: null,
          attachmentStatus: false,
        };
      }
    }
    case "severityLevel": {
      if (value) {
        return {
          ...state,
          severityLevel: value,
          severityLevelStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          severityLevel: "",
          severityLevelStatus: "unchecked",
        };
      }
    }
    default:
      return state;
  }
};

export const manageComplaintsDateFilter = {
  formDate: "",
  endDate: "",
  severityLevel: "",
  product: "",

  formDateStatus: "",
  endDateStatus: "",
  severityLevelStatus: "",
  productStatus: "",
};

export const manageComplaintsDateFilterMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "formDate": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          formDate: value,
          formDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          formDate: "",
          formDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          formDate: value,
          formDateStatus: "error",
        };
      }
    }
    case "endDate": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          endDate: value,
          endDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          endDate: "",
          endDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          endDate: value,
          endDateStatus: "error",
        };
      }
    }
    case "severityLevel": {
      if (value) {
        return {
          ...state,
          severityLevel: value,
          severityLevelStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          severityLevel: "",
          severityLevelStatus: "unchecked",
        };
      }
    }
    case "product": {
      if (value) {
        return {
          ...state,
          product: value,
          productStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          product: "",
          productStatus: "unchecked",
        };
      }
    }

    default:
      return state;
  }
};
export const severityLevelOption = ["Critical", "High", "Medium", "Low"];

export const complaintStatus = ["Open", "Resolved", "Closed"];

//get all complain
export const allComplaints = gql`
  query GetAllComplaints(
    $status: String
    $customerName: String
    $fromDate: Date
    $toDate: Date
  ) {
    allComplaints(
      status: $status
      customerName: $customerName
      fromDate: $fromDate
      toDate: $toDate
    ) {
      success
      message
      data {
        complaintId
        customerName
        status
        productId
        salesOrder {
          id
        }
        user {
          employeeName
        }
        complaintDate
        description
        productPurchaseDate
        attachment
        createdAt
      }
    }
  }
`;

export const createComplaints = gql`
  mutation CreateComplaint($input: CreateComplaintInput!, $attachment: Upload) {
    createComplaint(input: $input, attachment: $attachment) {
      success
      message
    }
  }
`;

export const updateComplaints = gql`
  mutation UpdateComplaint($input: UpdateComplaintInput!) {
    updateComplaint(input: $input) {
      success
      message
      complaint {
        id
        complaintId
        customerName
        productId
        salesOrder {
          id
        }
        complaintDate
        description
        severityLevel
        attachment
      }
    }
  }
`;

export const deleteComplaints = gql`
  mutation DeleteComplaint($complaintId: String!) {
    deleteComplaint(complaintId: $complaintId) {
      success
      message
    }
  }
`;

export const UpdateComplaintStatus = gql`
  mutation UpdateComplaint($input: UpdateComplaintInput!) {
    updateComplaint(input: $input) {
      success
      message
      complaint {
        id
        complaintId
        customerName
        product {
          id
          productName
        }
        salesOrder {
          id
          orderDate
          orderType
        }
        complaintDate
        description
        severityLevel
        attachment
      }
    }
  }
`;

export const ExportComplaints = gql`
  mutation ExportComplaints($filter: ExportComplaintFilterInput) {
    exportComplaints(filter: $filter) {
      success
      error
      message
      downloadUrl
    }
  }
`;

export const GetComplaintById = gql`
  query ComplaintById($complaintId: String!) {
    complaintById(complaintId: $complaintId) {
      success
      message
      data {
        complaintId
        customerName
        productId
        productName

        attachment
        productPurchaseDate
        salesOrder {
          id
          soNumber
        }
        closedRemarks
        actionsTaken
        customerSatisfaction
        complaintDate
        resolutionDate
        resolutionDescription
        description
        severityLevel
        complaintDate
        status
        resolutionDescription
        createdAt
        updatedAt
      }
    }
  }
`;

export const GetComplaintsByCustomerName = gql`
  query GetComplaintsByCustomerName(
    $customerName: String!
    $fromDate: Date
    $toDate: Date
  ) {
    complaintsByCustomerName(
      customerName: $customerName
      fromDate: $fromDate
      toDate: $toDate
    ) {
      success
      message
      data {
        complaintId
        status
        complaintDate
        description
      }
    }
  }
`;

export const getCompletedDeliveries = gql`
  query {
    completedDeliveries {
      id
      deliveryId
      salesOrder
      salesOrderDate
      repName
      repCode
      customerName
      customerAddress
      typeOfCreation
      deliveryStatus
      visitStatus
      deliveredDate
      deliveredOn
      reason
      contactPerson
      contactNumber
      paymentMode
      createdAt
      updatedAt
      deliveryProducts {
        id
        productCode
        productName
        quantity
        createdAt
        updatedAt
      }
    }
  }
`;

export const GetUserNotifications = gql`
  query GetUserNotifications($userId: ID!) {
    getNotificationByUserid(userId: $userId) {
      data {
        id
        module
        message
        status
        createdAt
      }
      success
      error
      message
    }
  }
`;

export const GetNotificationById = gql`
  query GetNotificationById($id: ID!) {
    getNotificationById(id: $id) {
      data {
        id
        module
        message
        status
        createdAt
      }
      success
      error
      message
    }
  }
`;

export const GetNotificationCount = gql`
  query GetUnreadNotificationCount($userId: ID!) {
    getUnreadCount(userId: $userId)
  }
`;

export const productsData = gql`
  query {
    allProducts {
      success

      error

      message

      data {
        id

        productCode

        productName

        productCategory

        productBrandCode

        productBrand

        productUom

        baseUom

        conversion

        vat

        bas

        cod

        csh

        smt

        vansl

        createdAt

        lastupdate
      }
    }
  }
`;

export const productsSalesData = gql`
  query {
    completedDeliveries {
      success
      error
      message
      data {
        id
        repCode
        deliveryStatus
        createdAt
        salesOrder {
          id
          orderDate
          totalAmount
        }
      }
    }
  }
`;

export const completedDeliveries = gql`
  query {
    completedDeliveries {
      success
      error
      message
      data {
        id
        salesOrder {
          id
          soNumber
        }
      }
    }
  }
`;

export const getCompalaintsCustomerQuery = gql`
  query GetSalesOrderLite($id: Int!) {
    getSalesorderLite(id: $id) {
      success
      message
      error
      data {
        id
        orderDate
        customer {
          id
          customerName
        }
        salesorderproductSet {
          id
          product {
            id
            productName
          }
        }
      }
    }
  }
`;
